<template>
  <div class="tw-flex tw-items-center tw-gap-x-1 tw-text-sm tw-leading-none">
    <span class="sr-only">{{ label }} {{ text }}</span>
    <font-awesome-icon size="sm" :icon="icon" />
    <span>
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    text: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
}
</script>
